// src/services/outOfOfficeReportService.js
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({ baseURL: API_BASE_URL });

const authHeaders = (accessToken) => ({
  headers: {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  },
});

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });
  const qs = params.toString();
  return qs ? `?${qs}` : "";
};

/**
 * Location-tagged check-ins for the given filters.
 * @param {object} filters - { from, to, status, empId, department, limit, offset }
 * @returns {Promise<{rows: Array, pagination: object}>}
 */
export const getOutOfOfficeReport = (accessToken, filters = {}) =>
  api
    .get(`/api/attendance-report/out-of-office${buildQuery(filters)}`, authHeaders(accessToken))
    .then((res) => ({
      rows: res.data?.data || [],
      pagination: res.data?.pagination || { total: 0, limit: 0, offset: 0 },
    }));

/**
 * Per-employee day counts by location status.
 */
export const getOutOfOfficeSummary = (accessToken, filters = {}) =>
  api
    .get(
      `/api/attendance-report/out-of-office/summary${buildQuery(filters)}`,
      authHeaders(accessToken)
    )
    .then((res) => res.data?.data || []);

export default { getOutOfOfficeReport, getOutOfOfficeSummary };
